module.exports = __webpack_public_path__ + "static/media/g-3-d.88b7963f.jpg";